export default __webpack_public_path__ + "static/media/video-2.242ef664.webm";